import { useCanAccess } from "@/hooks/useCanAccess";
import { secondaryMenu } from "./menu";
import { NavLink } from "react-router-dom";
import { classNames } from "@/utils";
import { LinkIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { ChatRoom } from "@/types/chat";
import Badge from "@/components/Badge";
import usePrimaryMenu from "./usePrimaryMenu";
import { Disclosure, Transition } from "@headlessui/react";

interface Props {
  pendingChats: ChatRoom[];
}
const DesktopNavbar = ({ pendingChats }: Props) => {
  const canAccess = useCanAccess();
  const mainMenu = usePrimaryMenu({ pendingChatCount: pendingChats.length });

  return (
    <div className="flex flex-col flex-grow pt-5 bg-primary-700 overflow-y-auto">
      <NavLink to="/dashboard" className="flex items-center flex-shrink-0 px-4">
        <img
          className="h-8 w-auto"
          src="https://freesvg.org/img/student_hat_1.png"
          alt="Consultancy"
        />
        <p className="font-extrabold text-white px-3 text-xl">CAC Central</p>
      </NavLink>
      <div className="mt-5 flex-1 flex flex-col">
        <nav className="flex-1 px-2 pb-4 space-y-1">
          {mainMenu.map(
            (item, index) =>
              canAccess(item) && (
                <div key={index}>
                  <NavLink
                    key={item?.name}
                    to={item?.href}
                    className={({ isActive }) =>
                      classNames(
                        isActive
                          ? "bg-primary-800 text-white"
                          : "text-primary-100 hover:bg-primary-600",
                        "group flex items-center px-2 py-2 text-base font-medium rounded-md",
                      )
                    }
                  >
                    <item.icon
                      className="mr-3 flex-shrink-0 h-6 w-6 text-primary-300"
                      aria-hidden="true"
                    />
                    <span className="relative">
                      {item.name}
                      {item.name.toLowerCase() === "chat" && item.count ? (
                        <Badge className="left-12">{item.count}</Badge>
                      ) : null}
                    </span>
                  </NavLink>
                </div>
              ),
          )}
          {secondaryMenu.map((menu, index) => (
            <Disclosure as="div" className="px-2 p-2" key={index}>
              {({ open }) => (
                <>
                  <Disclosure.Button className="text-md cursor-pointer text-primary-100 font-medium flex items-center justify-between w-full hover:bg-primary-600 rounded-md py-2 px-3">
                    <span className="flex items-center">
                      <LinkIcon className="flex-shrink-0 h-6 w-6 text-primary-300 mr-3" />
                      {menu.name}
                    </span>
                    <ChevronDownIcon
                      className="flex-shrink-0 h-5 w-5 text-primary-300 ml-2 transition-transform duration-300"
                      style={{
                        transform: open ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    />
                  </Disclosure.Button>
                  <Transition
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 -translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 -translate-y-1"
                  >
                    <Disclosure.Panel className="flex flex-col">
                      {menu.subMenu.map(
                        (item: any) =>
                          canAccess(item) && (
                            <NavLink
                              key={item?.name}
                              to={item?.href}
                              className={({ isActive }) =>
                                classNames(
                                  isActive
                                    ? "bg-primary-800 text-white"
                                    : "text-primary-100 hover:bg-primary-600",
                                  "group flex items-center py-2 px-2 text-sm font-medium rounded-md w-full",
                                )
                              }
                            >
                              <item.icon
                                className="mr-3 flex-shrink-0 h-6 w-6 text-primary-300"
                                aria-hidden="true"
                              />
                              {item.name}
                            </NavLink>
                          ),
                      )}
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default DesktopNavbar;
